import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./GlobalLoader.css";

interface GlobalLoaderProps {
  message?: string;
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({
  message = "Loading...",
}) => {
  // Define the loading icon with appropriate size
  const loadingIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  return (
    <div className="global-loader">
      <div className="global-loader__content">
        <Spin indicator={loadingIcon} tip={message} />
      </div>
    </div>
  );
};

export default GlobalLoader;
